<div *ngIf="!loaderStatus()" class="h-100 w-100 padt-5">
  <mat-progress-bar [mode]="'indeterminate'">
  </mat-progress-bar>
</div>
<div class="tab-side-menu-wrapper">
  <div>
    <app-vertical-tab-list [list]="verticalTabList" (tabClick)="onTabClick($event)"></app-vertical-tab-list>
  </div>
  <div *ngIf="loaderStatus()">
    <div class="da-wrapper">
      <!-- top graph layer -->
      <div class="da-top-container">
        <!-- Brake Events Count vs Deceleration  -->
        <div class="da-top-tile da-tile-content">
          <div class="da-tile-title">
            {{ classType === 'RUL_BRAKE_PAD' ? descriptiveConfig?.chart1?.nameBp : descriptiveConfig?.chart1?.nameCp }}
          </div>
          <div class="chart-container">
            <app-pie-chart [pieChartData]="pieChartData"></app-pie-chart>
          </div>
        </div>
        <!--  No Of Braking Events vs Initial Speed -->
        <div class="da-top-tile  da-tile-content">
          <div class="da-tile-title">
            {{ classType === 'RUL_BRAKE_PAD' ? descriptiveConfig?.chart2?.nameBp : descriptiveConfig?.chart2?.nameCp }}
          </div>
          <div class="chart-container">
            <app-bar [barChartData]="barChartData"></app-bar>
          </div>
        </div>
        <!-- Pad Wear Rate -->
        <div class="da-top-tile  da-tile-content">
          <div class="da-tile-title">
            {{ classType === 'RUL_BRAKE_PAD' ? descriptiveConfig?.chart3?.nameBp : descriptiveConfig?.chart3?.nameCp }}
          </div>
          <div class="chart-container">
            <app-line [lineChartData]="lineChartData"></app-line>
          </div>
        </div>
      </div>
      <!-- bottom graph layer -->
      <!-- Brake Events Count - Initial Speed & Deceleration -->
      <div class="da-tile-content break-events-count">
        <div class="da-tile-title">
          {{ classType === 'RUL_BRAKE_PAD' ? descriptiveConfig?.chart4?.nameBp : descriptiveConfig?.chart4?.nameCp }}
        </div>
        <div class="chart-container">
          <app-grouped-bar [groupedBarChartData]="groupedBarChartData"></app-grouped-bar>
        </div>
      </div>
    </div>
  </div>
</div>